<template>
  <div class='tour'>
    <h1 class='daytour'>AMAZING NORTH OF MONTENEGRO</h1>
    <div class='tourPic'>
      <img src='@/assets/multidaytours/tour1/01.jpg'>
    </div>
    <div>
      <ul class='fa-ul'>
        <li> <span class='fa-li'><img style='width:35px;margin-left:0px;margin-top:0px;' src='@/assets/logo/lovcen-green.png'/></span>
          <a data-toggle='collapse' href='#tourDescription'><h4 class='titles'>Tour description</h4></a>
          <div class='collapse' id='tourDescription'>
            <p class="pasus">The major part of this tour will be spent in the north of Montenegro, mostly away from crowds, in mountainous region, while passing through many villages, spending time near clear mountain rivers, crossing deep canyons, visiting 3 national parks and 2 regional parks of nature, exploring natural and cultural UNESCO heritage, getting to know the culture of Montenegrin highlands, resting our eyes from some of the most famous lookouts in Montenegro, enjoying local delicacies, and having a fresh nights’ sleep after exciting day tours…</p>
            <p class="pasus">The tour will begin from the largest urban center to be mostly spent in the north of the country and ultimately finish, as Lord Byron wrote, with the view on the most beautiful merging of land and sea – Boka Bay.</p>
            <p class="pasus">In physical terms, the tour is not difficult as we will make sure to walk whenever we have a chance but only to the extent you feel comfortable. It includes rafting down the Tara River which in the summer is an easy adventure, panorama ski lift drive (optional), Skadar Lake boat cruising with bird watching and taking a swim if preferred. Horse riding, kayaking and zip line are additional options we can include if you wish so.</p>
            <p class="pasus">National parks are far-known for its natural qualities – Durmitor for its geomorphology, glacial lakes and deep canyons, Biogradska Gora for its primeval untouched forest, one of the three of such kind remained in Europe, which surrounds the amazing glacial lake, Prokletije for its impressive peaks and values, hydro phenomena and Lovcen for its spectacular views on Boka bay.</p>
            <p class="pasus">While on this tour you will get to know the border regions of Montenegro, inhabited by minorities, where different cultures permeate and Islam, Catholicism and Orthodoxy coexist in harmony.</p>
            <p class="pasus">You will spend time in regions known for their dairy specialties, quality lamb, veal and freshwater fish but also for homegrown fruits and vegetables. You will have the opportunity to taste famous Montenegrin smoked ham, red wine, mead and brandy.</p>
            <p class="pasus">And local highlanders will welcome you kindly and proudly…</p>
            <p class='pasus'>Cheers!</p>
          </div>
        </li>
        <li> <span class='fa-li'><img style='width:35px;margin-left:0px;margin-top:0px;' src='@/assets/logo/lovcen-green.png'/></span>
          <a data-toggle='collapse' href='#tourDetails'><h4 class='titles'>Tour details</h4></a>
          <div class='collapse' id='tourDetails'>
            <p class="pasus">Type of tour: Private </p>
            <p class="pasus">Availability: June – October  </p>
            <p class="pasus">Group size: 1-7 </p>
            <p class="pasus">Departure from:  Podgorica </p>
            <p class="pasus">Difficulty level: easy </p>
            <p class="pasus">Duration: 8 days /7 nights </p>
          </div>
        </li>
        <li> <span class='fa-li'><img style='width:35px;margin-left:0px;margin-top:0px;' src='@/assets/logo/lovcen-green.png'/></span>
          <h4 class='titles'>Highlights</h4>
          <vue-picture-swipe :items='items'></vue-picture-swipe>
        </li>
        <li> <span class='fa-li'><img style='width:35px;margin-left:0px;margin-top:0px;' src='@/assets/logo/lovcen-green.png'/></span>
          <a data-toggle='collapse' href='#itinerary'><h4 class='titles'>Itinerary</h4></a>
          <ul class='collapse itinerary_days' id='itinerary'>
          <li>
            <a data-toggle='collapse' href='#day1'> <h5 class='sub-titles'>Day 1  -  Into the secret</h5></a>
            <div class='collapse' id='day1'>
              <p class="pasus">Welcome to the best kept secret in Europe! </p>
              <p class="pasus">After you land at Podgorica or Tivat airport, our driver/guide will meet you at the exit hall carrying a sign with your name.  After a short introduction you will start your journey to the north of the country. On our way to the first attraction and spectacular Ostrog monastery, we will enjoy the panoramic ride through the capital city of Podgorica to reach Ostrog after additional 45 minutes. After an hour long visit to the monastery we continue our drive through the scenic landscapes further to the higher altitudes passing through the second largest town in the country. On our way, we will pay a visit to the park of nature where the most famous Montenegrin canyoning adventure starts from to finally arrive at the lake plateau (at 1450 meters above sea level) and a tiny town of Zabljak where we spend the first night.  </p>
              <p class="pasus">Accommodation – 4 * hotel in Zabljak </p>
              <div class="tour-time">
                <p> <i class='fas fa-clock'></i> 2.5 hours</p>
                <p> <i class='fas fa-route'></i> 140 km</p>
              </div>
              <img class='daypic' src='@/assets/multidaytours/tour1/day1.jpg'>
            </div>
          </li>
          <li>
            <a data-toggle='collapse' href='#day2'> <h5 class='sub-titles'>Day 2 - Black Lake and Tara canyon - UNESCO natural heritage- Life among the shepherds, peaks and geological miracles</h5></a>
            <div class='collapse' id='day2'>
              <p class="pasus">The whole second day of our tour is reserved for exploring national park Durmitor, a UNESCO world heritage site. We will start from its pearl – Black Lake, take a walk around the lake enjoying the scenery, and visit the lookout offering a view on the deepest part of Tara canyon (1330m) </p>
              <p class="pasus">We will drive through the famous Durmitor villages following the route known as “Durmotro ring”, descend into the deep canyon of Susica River, have a look at the most prominent mountain in the north  (commonly called “the director of all mountains”), from different angles and get to explore local flora.  </p>
              <p class="pasus">We will pay a visit to a locality with medieval tombstones (stećci), enjoy a view on Piva canyon and Piva Lake, have a close look at geomorphology of Durmitor, visit a katun – shepherds’ village in the mountains, to finish the day and spend the night in Zabljak, a small town sitting at the highest elevation in the Balkans.   </p>
              <p class="pasus">Accommodation - 4 star hotel in Zabljak </p>
              <div class="tour-time">
                <p> <i class='fas fa-clock'></i> 3 hours</p>
                <p> <i class='fas fa-route'></i> 100 km</p>
              </div>
              <img class='daypic' src='@/assets/multidaytours/tour1/day2.jpg'>
            </div>
          </li>
          <li>
            <a data-toggle='collapse' href='#day3'><h5 class='sub-titles'>Day 3  -  Tear of Europe</h5></a>
            <div class='collapse' id='day3'>
              <p class="pasus">It is time to head downhill, dip our hands and wash our faces in the “tear of Europe”, which is another name for the clear Tara River. We will take a ride in rubber boats down the river rapids, enjoy the view from and on the spectacular Djurdjevica Tara bridge, if preferred so, do the zip line which is one of the longest in Europe, feel the charms of centuries’ old black pine forest, take a walk by super-fast stream and enjoy local delicacies at lunch after the rafting.    </p>
              <p class="pasus">We will finish our day in the charming little town of Kolasin.  </p>
              <p class="pasus">Accommodation: 4-star hotel in Kolasin </p>
              <div class="tour-time">
                <p> <i class='fas fa-clock'></i> 2 hours</p>
                <p> <i class='fas fa-route'></i> 90 km</p>
              </div>
              <img class='daypic' src='@/assets/multidaytours/tour1/day3.jpg'>
            </div>
          </li>
          <li>
            <a data-toggle='collapse' href='#day4'><h5 class='sub-titles'>Day 4  - Tree hugging and cheese tasting</h5></a>
            <div class='collapse' id='day4'>
              <p class="pasus">This day will be spent at a slower pace. We will begin it with a short walk through the city center; get to know the town’s glorious antifascist history, visit a local market and then the national park Biogradska Gora and beautiful Biogradsko Lake. We will take a few hours long stroll around the lake and have a deeper experience of the park’s flora and fauna, hugging over 400 years old trees.    </p>
              <p class="pasus">On this day we will have a real gastronomic experience, too. We will find out how the famous Kolasin leafy cheese is made and taste other local specialties in the authentic environment of a local rural family household.  </p>
              <p class="pasus">The afternoon hours can be spent walking by the Tara River or taking the panoramic ski lift ride and enjoying the view from one of the Bjelasica mountain tops.   </p>
              <p class="pasus">Accommodation: 4-star hotel in Kolasin </p>
              <div class="tour-time">
                <p> <i class='fas fa-clock'></i> 1 hour 15 minutes</p>
                <p> <i class='fas fa-route'></i> 60 km</p>
              </div>
              <img class='daypic' src='@/assets/multidaytours/tour1/day4.jpg'>
            </div>
          </li>
          <li>
            <a data-toggle='collapse' href='#day5'><h5 class='sub-titles'>Day 5  -  Multicultural heritage and hydro phenomena</h5></a>
            <div class='collapse' id='day5'>
              <p class="pasus">Montenegro is a country of tribal tradition so this day will commence with a visit to a territory of Vasojevici tribe, one of the largest and best known in the country. They are proud of their mountain Komovi (they call it the “tsar of mountains”) which together with its surroundings has a status of Regional Park.     </p>
              <p class="pasus">Montenegro is also the country inhabited by national minorities so the other part of the day will be reserved for natural beauties of the region they live in and for their cultural heritage. Our program includes a walk by the largest glacial lake in Montenegro – Plavsko Lake, a visit to famous Alipasini springs and Skakavica Eye – a spring of Skakavica River but also to a famous Redzepagica Tower, the architectural symbol of Plav.  </p>
              <p class="pasus">Accommodation: 4-star hotel in Kolasin </p>
              <p class="pasus"> </p>
              <div class="tour-time">
                <p> <i class='fas fa-clock'></i> 3.5 hours</p>
                <p> <i class='fas fa-route'></i> 200 km</p>
              </div>
              <img class='daypic' src='@/assets/multidaytours/tour1/day5.jpg'>
            </div>
          </li>
          <li>
            <a data-toggle='collapse' href='#day6'><h5 class='sub-titles'>Day 6 - Down through the canyon to the calm waters and kingdom of lilies and birds</h5></a>
            <div class='collapse' id='day6'>
              <p class="pasus">On the sixth day of our tour we will slowly descend to lower regions through the spectacular Moraca River canyon, 1000 meters deep, with clear green mountain waters flowing through it. We will stop to visit another celebrated Montenegrin Monastery, known for its fresco painting, woodcut and long tradition to arrive at the largest lake in the Balkans – Skadar Lake and the national park of the same name after approximately another hour of drive.  </p>
              <p class="pasus">We will then enjoy our two-hour long boat cruise surrounded by water lilies and birds. After the ride, we will have the chance to taste fish delicacies in a charming little town Virpazar, known for fish and wine. Worth visiting is Godinje village as well, with the architecture the subject of many studies and whose small family wineries are the right choice for all lovers of new wine flavors. On our way to the village there are a number of nice lookouts with stunning views on the most of Skadar Lake.  </p>
              <p class="pasus">We are back in Podgorica in the afternoon.  </p>
              <p class="pasus">Accommodation:  4 star hotel in Podgorica </p>
              <div class="tour-time">
                <p> <i class='fas fa-clock'></i> 2 hours 15 minutes</p>
                <p> <i class='fas fa-route'></i> 140 km</p>
              </div>
              <img class='daypic' src='@/assets/multidaytours/tour1/day6.jpg'>
            </div>
          </li>
          <li>
           <a data-toggle='collapse' href='#day7'><h5 class='sub-titles'>Day 7 - Old Montenegro beauties</h5></a>
            <div class='collapse' id='day7'>
              <p class="pasus">On our last day we will again set out to higher altitudes and visit the region we popularly call “Old Montenegro” – the region of fierce stone and nice forests which provided shelter to Montenegrins during their centuries long battles against Ottomans and other powerful conquerors. We will take a walk through the old city center of Cetinje, the historical capital of Montenegro and make a circle around the “Montenegrin Olimp”, a sacred Lovcen Mountain, and pass through the national park of the same name from where we will enjoy the most splendid view on one of the most beautiful bays in the world – Boka Bay. We will climb the stairs (optional) to the highest mausoleum in Europe where the most eminent Montenegrin in its history – Petar II Petrovic Njegis is buried. On our way back we will vist the best-known Montenegrin village Njegusi where we get to see the traditional way of smoking ham and have an opportunity to taste it.   </p>
              <p class="pasus">Finally, we will once again see the shore of Skadar Lake, go through the charming little town on the coast Rijeka Crnojevica and have a look from a spectacular lookout Pavlova strana on meanders of what it used to be Crnojevica River.   </p>
              <p class="pasus">We are back in Podgorica in the afternoon. </p>
              <p class="pasus">Accommodation:  4-star hotel in Podgorica </p>
              <div class="tour-time">
                <p> <i class='fas fa-clock'></i> 2.5 hours</p>
                <p> <i class='fas fa-route'></i> 125 km</p>
              </div>
              <img class='daypic' src='@/assets/multidaytours/tour1/day7.jpg'>
            </div>
          </li>
          <li>
           <a data-toggle='collapse' href='#day8'> <h5 class='sub-titles'>Day 8  - Departure day</h5></a>
            <div class='collapse' id='day8'>
              <p class='pasus'>On your last day, you will have breakfast as usual after which our driver will pick you up and take you directly to the airport.</p>
              <div class="tour-time">
                <p> <i class='fas fa-clock'></i> 15 minutes</p>
                <p> <i class='fas fa-route'></i> 10 km</p>
              </div>
            </div>
          </li>

          </ul>
         </li>
         <li> <span class='fa-li'><img style='width:35px;margin-left:0px;margin-top:0px;' src='@/assets/logo/lovcen-green.png'/></span>
            <a data-toggle='collapse' href='#prices'> <h4 class='titles'>PRICES: based on the number of people in your group</h4></a>
            <div class='collapse' id='prices'>
            <ul class='square'>
              <li>1950 euro per person when two traveling</li>
              <li>1500 euro per person when four traveling</li>
              <li>1350 euro per person when six traveling</li>
              <li>For bigger groups on request</li>
              <li>Single room supplement: 250 EUR</li>
              <li>
                  <p class='pasus'>TOUR DATES: On request</p>
              </li>
            </ul>
            </div>
          </li>
         <li> <span class='fa-li'><img style='width:35px;margin-left:0px;margin-top:0px;' src='@/assets/logo/lovcen-green.png'/></span>
            <a data-toggle='collapse' href='#included'> <h4 class='titles'>Included in the price</h4></a>
            <div class='collapse' id='included'>
            <ul class='square'>
              <li>Accommodations for all nights</li>
              <li>Transportation (van or car) </li>
              <li>Breakfast and dinner for all days</li>
              <li>Lunch on the days 2, 3, and 4</li>
              <li>Bottle of water - 0.5l each day</li>
              <li>Transfer to the airport the last day</li>
              <li>Rafting, professional guide and safety equipment</li>
              <li>Private boat tour on Skadar Lake (2h) </li>
              <li>Entrance fees for all national and regional parks</li>
              <li>Our on-site assistance 24/7</li>
              <li>Licensed tour guide</li>
              <li>Map of Montenegro</li>
            </ul>
            </div>
          </li>
          <li> <span class='fa-li'><img style='width:35px;margin-left:0px;margin-top:0px;' src='@/assets/logo/lovcen-green.png'/></span>
            <a data-toggle='collapse' href='#notincluded'> <h4 class='titles'>Not included in price</h4></a>
            <div class='collapse' id='notincluded'>
              <ul class='square'>
                <li>Options as mentioned</li>
                <li>Lunches not specified in the program</li>
                <li>Drinks and tips</li>
                <li>Personal expenses</li>
              </ul>
            </div>
          </li>
          <li> <span class='fa-li'><img style='width:35px;margin-left:0px;margin-top:0px;' src='@/assets/logo/lovcen-green.png'/></span>
            <a data-toggle='collapse' href='#info'> <h4 class='titles'>Practical info</h4></a>
            <div class='collapse' id='info'>
              <ul class='square'>
                <li class='pasus'> We recommend that you always carry a jacket, a cap, sunglasses and shoes adequate to mountain conditions and a bathing suit. Weather conditions in the mountains frequently vary.     </li>
                <li class='pasus'> The altitude difference we make is around 1850 meters. We start at 50 meters above sea level and the highest point we reach is at 1900 meters above sea level.    </li>
                <li class='pasus'> Prices at restaurants and cafes are very affordable.  </li>
                <li class='pasus'> The currency is euro.    </li>
              </ul>
            </div>
          </li>
          <li><span class='fa-li'><img style='width:35px;margin-left:0px;margin-top:0px;' src='@/assets/logo/lovcen-green.png'/></span>
           <a data-toggle='collapse' href='#optional'> <h4 class='titles'>Optional</h4></a>
            <div class='collapse' id='optional'>
              <ul class='square'>
                <li class="pasus">Additional walks during the tour </li>
                <li class="pasus">Itinerary changes during the tour can be agreed (do not affect the price) </li>
                <li class="pasus">Zip line over Tara canyon (ticket price = 20 EUR) </li>
                <li class="pasus">Boat ride on Biogradsko or Black Lake (1h = 8 EUR). </li>
                <li class="pasus">Horse Riding  </li>
                <li class="pasus">Panoramic ski lift ride (8 EUR) </li>
              </ul>
            </div>
          </li>
      </ul>
    </div>

  </div>

</template>

<script>
// import VuePictureSwipe from 'vue-picture-swipe';
export default {
  data () {
    return {
      items: [
        {
          src: require('@/assets/multidaytours/tour1/day1.jpg'),
          thumbnail: require('@/assets/multidaytours/tour1/day1.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/multidaytours/tour1/day2.jpg'),
          thumbnail: require('@/assets/multidaytours/tour1/day2.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/multidaytours/tour1/day3.jpg'),
          thumbnail: require('@/assets/multidaytours/tour1/day3.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/multidaytours/tour1/day4.jpg'),
          thumbnail: require('@/assets/multidaytours/tour1/day4.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/multidaytours/tour1/day5.jpg'),
          thumbnail: require('@/assets/multidaytours/tour1/day5.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/multidaytours/tour1/day6.jpg'),
          thumbnail: require('@/assets/multidaytours/tour1/day6.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/multidaytours/tour1/day7.jpg'),
          thumbnail: require('@/assets/multidaytours/tour1/day7.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/multidaytours/tour1/01.jpg'),
          thumbnail: require('@/assets/multidaytours/tour1/01.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/multidaytours/tour1/08.jpg'),
          thumbnail: require('@/assets/multidaytours/tour1/08.jpg'),
          w: 0,
          h: 720
        }
      ]
    }
  }
}
</script>

<style scoped>
h1 {
  background-color: rgba(113, 186, 107, 0.9);
  border-radius: 3px;
  padding: 5px;
}
ul.square {
  list-style-type: square;
  text-align: left;
}
ul.none {
  list-style-type: none;
  text-align: left;
}

.tourPic {
  margin-top: 5vh;
  width: 100%;
}
.tourPic img {
  width: 100%;
}
.tour {
  padding-left: 10vw;
  padding-right: 10vw;
  padding-top: 15vh;
}
.daypic {
  width: 60vw;
  margin-bottom:20px;
}
.pasus {
  text-align: justify;
}
.row {
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
}

.cont {
  position: relative;
  text-align: center;
  color: white;
}
.link {
  text-decoration: none;
}
.daytrips {
  padding-top: 10vw;
}
</style>



// WEBPACK FOOTER //
// src/components/MT1_AmazingNorth.vue